var render = function render(_c,_vm){return _c('div',_vm._l((_vm.props.row[_vm.props.column]),function(rate,index){return _c('div',{key:index,staticClass:"align-info-value"},[_c('p',{staticClass:"mb-0"},[_vm._v(_vm._s(rate.activity_rate.name)+":  ")]),_c('format',{attrs:{"value":rate.rate_value,"isP":true}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }